import { getElementsById } from "core-integration/src/store/elements/reducers";
import { getSavedPicks } from "core-integration/src/store/squad/reducers";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import AddElement from "plos/src/components/AddElement";
import { Button } from "plos/src/components/buttons/Button";
import ElementDialogButton from "plos/src/components/ElementDialogButton";
import ElementInTable from "plos/src/components/ElementInTable";
import {
  listTableCell,
  listTableElement,
  listTableElementWrap,
  listTablePlaceholderButtonWrap,
  listTablePositionCell,
  listTableRowStyles,
} from "plos/src/styles/listTables.css";
import { visuallyHidden } from "plos/src/styles/utils.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import OverlayCells from "../../../ListViewTable/OverlayCells";
import { TransfersListTableRowProps } from "./types";

const TransfersListTableRow = ({
  currencyDivisor,
  elementTypesByPosition,
  showElementType,
  pos,
  proposedElements,
  handleOpenElemListSheet,
  handleElementClick,
  overlay,
  stats,
  columnCount,
}: TransfersListTableRowProps) => {
  const { t } = useTranslation("transfers");

  const teamsById = useSelector(getTeamsById);
  const savedPicks = useSelector(getSavedPicks);
  const elementsById = useSelector(getElementsById);

  let element = proposedElements[pos];
  // TODO - We need a visual indicator of the row elementState, in the past we
  // have rendered the '0' shirt instead of the regular one
  let elementState: "original" | "removed" | "replaced" = "original";
  if (!element) {
    element = elementsById[savedPicks[pos].element];
    elementState = "removed";
  } else if (element.id !== savedPicks[pos].element) {
    elementState = "replaced";
  }

  if (!elementTypesByPosition) {
    return null;
  }

  const pickPrices =
    elementState === "replaced"
      ? { selling_price: element.now_cost, purchase_price: element.now_cost }
      : {
          selling_price: savedPicks[pos].selling_price,
          purchase_price: savedPicks[pos].purchase_price,
        };

  return (
    <tr className={listTableRowStyles}>
      {elementState !== "removed" ? (
        <>
          <th scope="row" className={listTableElement}>
            <span className={visuallyHidden}>
              {element.web_name}, {teamsById[element.team].name}
            </span>
            <div className={listTableElementWrap} aria-hidden="true">
              <ElementDialogButton elementId={element.id} variant="list" />
              <ElementInTable
                element={element}
                team={teamsById[element.team]}
                actionMe={() => handleElementClick(pos)}
                renderDreamTeam={element.in_dreamteam}
              />
            </div>
          </th>
          <OverlayCells
            overlay={overlay}
            element={element}
            stats={stats}
            pickPrices={pickPrices}
            currencyDivisor={currencyDivisor}
          />
          <td className={listTableCell}>
            <AddElement element={element} filterByElementTypeOnRemove />
          </td>
        </>
      ) : (
        <th className={listTablePositionCell} colSpan={columnCount + 2}>
          <div className={listTablePlaceholderButtonWrap}>
            <Button
              appearance="tonal"
              size="small"
              onPress={() => {
                showElementType(elementTypesByPosition[pos].thisType.id);
                handleOpenElemListSheet();
              }}
            >
              {t("select", "Select")}{" "}
              {elementTypesByPosition[pos].thisType.singular_name}
            </Button>
          </div>
        </th>
      )}
    </tr>
  );
};

export default TransfersListTableRow;
